import { Chip as MuiChip, SxProps } from '@mui/material';
import { CustomerMatchState, MatchStateLabel } from '@models/customer';

const colorByState: Record<CustomerMatchState, 'success' | 'warning' | 'default'> = {
  Confirmed: 'success',
  NeedsReview: 'warning',
  MergedAway: 'default',
};

interface MatchStateChipProps {
  matchState: CustomerMatchState;
  id?: string;
  sxProps?: SxProps;
}

/**
 * Badge for the in-house customer match review state (Confirmed / Needs Review /
 * Merged Away). Used on the Customer list and Customer detail pages.
 */
export const MatchStateChip = ({ matchState, id, sxProps }: MatchStateChipProps) => (
  <MuiChip
    size='small'
    label={MatchStateLabel[matchState]}
    color={colorByState[matchState]}
    variant='outlined'
    aria-label={`Match state: ${MatchStateLabel[matchState]}`}
    data-testid={id}
    sx={sxProps}
  />
);
